import {
  AngularFirestore,
  AngularFirestoreCollection
} from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Ampa} from '../model/ampa'
import {User} from '../model/user'

import * as firebase from 'firebase';



@Injectable()
export class AmpaService {
  ampasCollectionRef: AngularFirestoreCollection<Ampa>;
  ampa$: Observable<Ampa[]>;

  constructor (
  //private config: AppConfig,
private afs: AngularFirestore) {
  //this.ampasCollectionRef = this.afs.collection<Ampa>(this.config.getColletionFirebase());
  //Si configuramos un fichero de configuración, aquí no utilizaríamos 'ampas'
  //utilizaríamos this.config.getAmpasCollectionFirebase()
  this.ampasCollectionRef = this.afs.collection<Ampa>('ampas');
  this.ampa$ = this.ampasCollectionRef.snapshotChanges().map(actions => {
    return actions.map(action => {
      const data = action.payload.doc.data() as Ampa;
      const id = action.payload.doc.id;
      return { id, ...data };
    });
  });

  }

  // nos traemos los ampainformacion del ampa utilizando el id de ampa
  //que tiene el usuario en su documento
  //Sólo se encarga de recuperar un Ampa, nada más y nada menos
  obtenerAMPAInformacion(user: User): Ampa{
    console.log('obtenerAMPAInformacion')

    firebase.firestore().collection('ampas')
    .where('ampa','==', user.ampa)
    .get()
    .then(snapshot => {
      if (snapshot.size >0){
        //this.mostrarbotonanadirampa = false;
        //this.mostrarformulario = true;
        firebase.firestore().collection('ampas')
        .where('ampa','==', user.ampa)
        .get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                var elemento = doc.data();
                console.log('ampainformacion: ',doc.data())


                  //console.log('doc.id:', this.id)
                  //En Elemento tenemos los datos del Ampa que necesitamos
                  //simplemente convertimos Elemento a un Ampa y lo metemos en this.ampa
                  let ampa: Ampa = elemento as Ampa;
                  return ampa;

            });
        })
        .catch(err => {
            console.log('Error getting documents', err);
            return ;
        });


      }else
        return;
    })
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/ampaService.ts